/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultApiResponse from '../model/DefaultApiResponse';
import ProtoDocumentMetadata from '../model/ProtoDocumentMetadata';

/**
* ProtoDocumentMeta service.
* @module api/ProtoDocumentMetaApi
* @version 1.0.0
*/
export default class ProtoDocumentMetaApi {

    /**
    * Constructs a new ProtoDocumentMetaApi. 
    * @alias module:api/ProtoDocumentMetaApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Obtener metadatos del precontrato
     * Devuelve los metadatos de documentos para un ID específico.
     * @param {Number} precontractId Id del precontract
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProtoDocumentMetadata} and HTTP response
     */
    apiV1MyaccountProtoDocumentMetaPrecontractIdGetWithHttpInfo(precontractId) {
      let postBody = null;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentMetaPrecontractIdGet");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ProtoDocumentMetadata;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_document_meta/{precontract_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Obtener metadatos del precontrato
     * Devuelve los metadatos de documentos para un ID específico.
     * @param {Number} precontractId Id del precontract
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProtoDocumentMetadata}
     */
    apiV1MyaccountProtoDocumentMetaPrecontractIdGet(precontractId) {
      return this.apiV1MyaccountProtoDocumentMetaPrecontractIdGetWithHttpInfo(precontractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Actualiza metadatos del precontrato
     * Actualiza los metadatos para un ID específico
     * @param {Number} precontractId Id del precontract
     * @param {module:model/ProtoDocumentMetadata} protoDocumentMetadata 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/DefaultApiResponse} and HTTP response
     */
    apiV1MyaccountProtoDocumentMetaPrecontractIdPostWithHttpInfo(precontractId, protoDocumentMetadata) {
      let postBody = protoDocumentMetadata;
      // verify the required parameter 'precontractId' is set
      if (precontractId === undefined || precontractId === null) {
        throw new Error("Missing the required parameter 'precontractId' when calling apiV1MyaccountProtoDocumentMetaPrecontractIdPost");
      }
      // verify the required parameter 'protoDocumentMetadata' is set
      if (protoDocumentMetadata === undefined || protoDocumentMetadata === null) {
        throw new Error("Missing the required parameter 'protoDocumentMetadata' when calling apiV1MyaccountProtoDocumentMetaPrecontractIdPost");
      }

      let pathParams = {
        'precontract_id': precontractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = DefaultApiResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/proto_document_meta/{precontract_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Actualiza metadatos del precontrato
     * Actualiza los metadatos para un ID específico
     * @param {Number} precontractId Id del precontract
     * @param {module:model/ProtoDocumentMetadata} protoDocumentMetadata 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/DefaultApiResponse}
     */
    apiV1MyaccountProtoDocumentMetaPrecontractIdPost(precontractId, protoDocumentMetadata) {
      return this.apiV1MyaccountProtoDocumentMetaPrecontractIdPostWithHttpInfo(precontractId, protoDocumentMetadata)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
